<template>
  <component
    :is="componentise(value.type)"
    :class="$style.base"
    :style="style"
    :value="value"
    @loaded="$emit('loaded', $event)"
    @loading="$emit('loading', $event)"
  ></component>
</template>
<script>
import {
  ELEMENT_TYPE_DESIGN,
  ELEMENT_TYPE_EXTERNAL,
  ELEMENT_TYPE_GROUP,
  ELEMENT_TYPE_TEXT,
  ELEMENT_TYPE_UPLOAD
} from '../constants.js';

export default {
  name: 'EditorItem',
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    style() {
      return {
        top: `${this.value.top}%`,
        left: `${this.value.left}%`,
        height: `${this.value.height}%`,
        width: `${this.value.width}%`,
        zIndex:
          this.$compositionRenderer.config.baseLayerZIndex +
          this.value.layerLevel,
        transform: `rotate(${this.value.rotation || 0}deg)`
      };
    }
  },
  methods: {
    componentise(type) {
      switch (type) {
        case ELEMENT_TYPE_TEXT:
          return 'EditorItemText';
        case ELEMENT_TYPE_DESIGN:
          return 'EditorItemDesign';
        case ELEMENT_TYPE_UPLOAD:
          return 'EditorItemUpload';
        case ELEMENT_TYPE_EXTERNAL:
          return 'EditorItemExternal';
        case ELEMENT_TYPE_GROUP:
          return 'EditorItemGroup';
      }
      return 'EditorItemBase';
    }
  }
};
</script>
<style lang="scss" module>
.base {
  position: absolute;
  line-height: 0;
  max-width: none;
  max-height: none;
  min-width: 0;
  min-height: 0;
}
</style>
